export type LanguageAlternate = {
  href: string;
  label: "EN" | "PL";
};

const LANGUAGE_ALTERNATES: Record<string, LanguageAlternate> = {
  "/aplikacje-bluetooth": {
    href: "/mobile-app-with-bluetooth",
    label: "EN",
  },
  "/pl/aplikacje-bluetooth": {
    href: "/mobile-app-with-bluetooth",
    label: "EN",
  },
  "/mobile-app-with-bluetooth": {
    href: "/aplikacje-bluetooth",
    label: "PL",
  },
  "/programowanie-firmware-ble": {
    href: "/firmware-development-company",
    label: "EN",
  },
  "/pl/programowanie-firmware-ble": {
    href: "/firmware-development-company",
    label: "EN",
  },
  "/firmware-development-company": {
    href: "/programowanie-firmware-ble",
    label: "PL",
  },
};

export function normalizePathname(pathname: string): string {
  return pathname.replace(/\/+$/, "") || "/";
}

export function getLanguageAlternate(
  pathname: string,
): LanguageAlternate | undefined {
  return LANGUAGE_ALTERNATES[normalizePathname(pathname)];
}
